import { z } from 'zod';
import i18n from '../config/i18n';
import { ORDER_AGAIN_OPTIONS, REVIEW_HIGHLIGHTS } from '../types/review';

const t = (key: string) => i18n.t(key);

export const getCreateReviewSchema = () =>
  z.object({
    rating: z
      .number()
      .min(1, t('validation.ratingRequired'))
      .max(5, t('validation.ratingMax')),
    reviewerName: z
      .string()
      .min(2, t('validation.reviewNameMin'))
      .max(100, t('validation.reviewNameMax')),
    comment: z
      .string()
      .max(1000, t('validation.commentMax'))
      .optional(),
    email: z
      .string()
      .email(t('validation.emailInvalid'))
      .optional()
      .or(z.literal('')),
    highlights: z
      .array(z.enum(REVIEW_HIGHLIGHTS))
      .optional(),
    wouldOrderAgain: z
      .enum(ORDER_AGAIN_OPTIONS)
      .optional(),
    agreeToPublish: z
      .boolean()
      .refine((val) => val === true, {
        message: t('validation.agreeToPublish'),
      }),
  });

export const getUpdateReviewSchema = () =>
  z.object({
    rating: z
      .number()
      .min(1, t('validation.ratingMin'))
      .max(5, t('validation.ratingAtMost'))
      .optional(),
    reviewerName: z
      .string()
      .min(2, t('validation.reviewNameMin'))
      .max(100, t('validation.reviewNameMax'))
      .optional(),
    comment: z
      .string()
      .max(1000, t('validation.commentMax'))
      .optional(),
    highlights: z
      .array(z.string())
      .optional(),
    isEnabled: z.boolean().optional(),
    adminNotes: z
      .string()
      .max(500, t('validation.adminNotesMax'))
      .optional(),
  });

/** @deprecated Use getCreateReviewSchema() for i18n support */
export const createReviewSchema = getCreateReviewSchema();
/** @deprecated Use getUpdateReviewSchema() for i18n support */
export const updateReviewSchema = getUpdateReviewSchema();
export type CreateReviewFormData = z.infer<ReturnType<typeof getCreateReviewSchema>>;
export type UpdateReviewFormData = z.infer<ReturnType<typeof getUpdateReviewSchema>>;
